export const BASE = {
  method: {
    get: 'GET',
    put: 'PUT',
    post: 'POST',
    patch: 'PATCH',
    delete: 'DELETE'
  },
  protocol: {
    http: 'http',
    https: 'https'
  }
};

export const CREDENTIALS = {
  user: 'S0015085033',
  password: '2.SAPIND'
};

export const MEA_SERVER_CONFIGURATION = {
  method: BASE.method.get,
  protocol: import.meta.env.VITE_API_PROTOCOL,
  host: import.meta.env.VITE_API_HOST,
  port: import.meta.env.VITE_API_PORT,
  headers: [],
  apiPath: '/api/v1/',
  resource: {
    signup: 'auth/signup/',
    signupConfirm: 'auth/confirm/',
    signUpResendEmail: 'auth/sendemail/',
    captchaCreate: 'auth/captcha/create/',
    captchaVerify: 'auth/captcha/verify/',
    login: 'auth/login/',
    reactivate: 'auth/reactivate/',
    refreshToken: 'auth/refresh-token',
    forgotPass: 'auth/forgot-pass',
    resetPass: 'auth/reset-pass',
    countries: 'countries/',
    register: 'register/',
    catalog: 'catalog/',
    catalogTypes: 'catalog/types/',
    catalogStatuses: 'catalog/statuses/',
    catalogEvents: 'catalog/events/',
    myEvents: 'my-events/',
    myAreaOverviewUpcomingEvents: 'my-area/overview/upcomingEvents/',
    myAreaOverviewOnDateEvents: 'my-area/overview/eventsOnDate/',
    eventStatuses: 'my-area/training/eventsStatus/',
    eventsAndSessionsRange: 'my-area/overview/eventsAndSessionsRange/',
    eventsAndSessionsOnDate: 'my-area/overview/eventsAndSessionsOnDate/',
    myAreaTrainingEvents: 'my-area/overview/trainingEvents/',
    eventDetails: 'event-details/',
    assigned: 'assigned/',
    agenda: 'agenda/',
    attachments: 'attachments/',
    notes: 'notes/',
    home: 'home/',
    customerEvents: 'customer-events',
    customerEventsSessions: 'customer-events/:eventId/sessions',
    customerEventsNotes: 'customer-events/:eventId/notes',
    customerEventsAttachments: 'customer-events/:eventId/attachments',
    customerEventsDownloadAttachments: 'customer-events/:eventId/attachments/:attachmentId/download'
  },
  query: null
};

export const CLIENT_LINKS = {
  achievementsAndCertificates: import.meta.env.ACHIEVEMENTS_AND_CERTIFICATES,
  teamAreaAchievements: import.meta.env.TEAM_AREA_ACHIEVEMENTS,
  managersReportEngine: import.meta.env.MANAGERS_REPORTS_ENGINE
};

export const DISABLE_ACHIEVEMENTS = true;
export const DISABLE_REPORT = true;

export const TEM_USER_ID = 1;

export const Prices = {
  StandardPrice: 6
};
